export { STREAK_FINISHES } from "@healthos/tokens";

export function StreakMedalArtwork({
  level,
  light,
  enamel,
}: {
  level: number;
  light: string;
  enamel: string;
}) {
  return (
    <g>
      <g transform="translate(100 96) scale(74 -74)" fill={light}>
        <path d="M0 -0.45 C-0.42 -0.43 -0.46 -0.05 -0.19 0.25 C-0.23 0.02 -0.07 0.02 -0.04 0.18 C0 0.35 -0.02 0.47 0.13 0.61 C0.09 0.28 0.4 0.2 0.4 -0.08 C0.4 -0.31 0.25 -0.45 0 -0.45Z" />
        <path
          d="M0.025 -0.35 C-0.13 -0.35 -0.2 -0.18 -0.065 -0.025 C-0.07 -0.14 0.06 -0.1 0.1 0.07 C0.23 -0.08 0.26 -0.35 0.025 -0.35Z"
          fill={enamel}
        />
      </g>
      {[1, 2, 3, 4].slice(0, Math.max(1, level)).map((dot) => (
        <circle
          key={dot}
          cx={100 + (dot - 1 - (Math.max(1, level) - 1) / 2) * 10}
          cy={143}
          r={2.3}
          fill={light}
        />
      ))}
    </g>
  );
}
